<template>
  <footer class="qfooter">
    <div class="qfooter__inner">
      <!-- Sol: Copyright -->
      <div class="qfooter__copy">
        <span class="qfooter__copy-text">
          &copy; {{ new Date().getFullYear() }}
          <span class="qfooter__brand">Quatro</span>
        </span>
      </div>

      <!-- Orta: Logo -->
      <div class="qfooter__logo">
        <v-img :src="footerLogo" height="22" contain></v-img>
      </div>

      <!-- Sağ: Geliştirici -->
      <div class="qfooter__dev">
        <span class="qfooter__dev-label">{{ $t("developed") }}</span>
        <a
          href="http://mobilulasim.com"
          class="qfooter__dev-link"
          target="_blank"
          rel="noopener"
        >
          İpos Mobil Ulaşım
        </a>
        <span class="qfooter__version">{{ $t("version") }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
import footerLogo from "../../../public/assets/img/quatro_black_logo.svg";
export default {
  data() {
    return { footerLogo };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

.qfooter {
  width: 100%;
  height: auto;
  background: #ffffff;
  border-top: 1px solid #e8edf5;
  font-family: "Plus Jakarta Sans", sans-serif;
  padding: 20px 20px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
}

.qfooter__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 1200px;
  margin: 0 auto;
}

/* ── Sol ── */
.qfooter__copy {
  flex: 1;
  min-width: 0;
}
.qfooter__copy-text {
  font-size: 1.25rem;
  color: #94a3b8;
  font-weight: 400;
  white-space: nowrap;
}
.qfooter__brand {
  font-weight: 700;
  color: #f97316;
  letter-spacing: 0.02em;
}

/* ── Orta ── */
.qfooter__logo {
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.qfooter__logo:hover {
  opacity: 1;
}

/* ── Sağ ── */
.qfooter__dev {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  min-width: 0;
  flex-wrap: wrap;
}
.qfooter__dev-label {
  font-size: 1rem;
  color: #94a3b8;
  font-weight: 400;
  white-space: nowrap;
}
.qfooter__dev-link {
  font-size: 1.15rem;
  font-weight: 600;
  color: #f97316;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.18s;
  position: relative;
}
.qfooter__dev-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 0;
  height: 1px;
  background: #f97316;
  transition: width 0.2s ease;
}
.qfooter__dev-link:hover {
  color: #ea6c00;
}
.qfooter__dev-link:hover::after {
  width: 100%;
}

.qfooter__version {
  font-size: 1.15rem;
  color: #cbd5e1;
  font-weight: 500;
  white-space: nowrap;
}

/* ── Mobile: 2 satır ── */
@media (max-width: 480px) {
  .qfooter__inner {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px 16px;
  }
  .qfooter__copy {
    flex: none;
    order: 2;
  }
  .qfooter__logo {
    flex: none;
    order: 1;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .qfooter__dev {
    flex: none;
    order: 3;
    justify-content: center;
  }
  .qfooter__dev-label,
  .qfooter__dev-link,
  .qfooter__version {
    font-size: 0.75rem;
  }

  .qfooter__copy-text {
    font-size: 1rem;
  }
}
</style>
